import { format } from 'date-fns';

import { Grid, Text } from '@simplywallst/ui-core';
import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';

type Props = {
  narrative: Narrative;
};

export const NarrativeTimestamp = ({ narrative }: Props) => {
  const { createdAt, updatedAt } = narrative;
  return (
    <Grid
      gap="8px"
      templateColumns="max-content max-content"
      alignItems="end"
      justifyContent="start"
    >
      <Grid
        templateColumns="max-content max-content"
        alignItems="center"
        gap="8px"
      >
        <Text typography="tiny" color="textSofter">
          Published
        </Text>
        <Text typography="tiny" color="textSolid">
          {format(new Date(createdAt), 'MMMM dd yyyy')}
        </Text>
      </Grid>
      {updatedAt && (
        <Grid
          templateColumns="max-content max-content"
          alignItems="center"
          gap="8px"
        >
          <Text typography="tiny" color="textSofter">
            Updated
          </Text>
          <Text typography="tiny" color="textSolid">
            {format(new Date(updatedAt), 'MMMM dd yyyy')}
          </Text>
        </Grid>
      )}
    </Grid>
  );
};
